// extracted by mini-css-extract-plugin
export default {"logout_button":"dtx05","logout_icon":"IjrDK","disabled":"kmaaB"};